export function getBillSerie(billNumber: string): string {
  return billNumber.replace(/[^LS|LI|LRS|LRI]/g, '')
}

export function getBillNumber(billNumber: string): number {
  return parseInt(billNumber.replace(/[^0-9]/g, ''))
}
